// Use require() instead of import to prevent eager module evaluation.
// apiClientBrowser uses window at module init time — lazy loading prevents that on the server.
// tslint:disable:no-require-imports
// typeof window === 'undefined' is not enough — the server-side window shim sets global.window.
// A real browser always has window.addEventListener; the shim does not.
const isServer = typeof window === 'undefined' || typeof window.addEventListener !== 'function';
const impl = isServer ? require('./apiServer') : require('./apiClientBrowser');

export const makeRequest = impl.makeRequest;
export const apiRequest = impl.apiRequest;
